import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
  connectAuthEmulator,
} from 'firebase/auth';
import { getApp } from './app';

const app = getApp();
const auth = getAuth(app);

let connectedEmulator = false;
if (!connectedEmulator && process.env.NEXT_PUBLIC_EMULATOR_MODE === 'true') {
  connectAuthEmulator(auth, 'http://localhost:9099');
  connectedEmulator = true;
}

setPersistence(auth, browserLocalPersistence);

export { auth };
